const o=".accordion-group ::slotted(ngc-accordion:not(:last-child)){--ngc-accordion-border-bottom: var(--ngc-accordion-group-divider) }";export{o as default};
